import { render, staticRenderFns } from "./edit-follow-up-item.vue?vue&type=template&id=27d7965f&scoped=true&"
import script from "./edit-follow-up-item.vue?vue&type=script&lang=js&"
export * from "./edit-follow-up-item.vue?vue&type=script&lang=js&"
import style0 from "./edit-follow-up-item.vue?vue&type=style&index=0&id=27d7965f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7965f",
  null
  
)

export default component.exports